import { mediaUrl } from "@/lib/api";

function ytId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
}

// Renders a YouTube embed, a Vimeo embed, or an uploaded/native video file.
export default function VideoEmbed({ url, className = "" }) {
  if (!url) return null;
  const yt = ytId(url);
  if (yt) {
    return (
      <div className={`relative w-full overflow-hidden rounded-xl border border-white/10 ${className}`} style={{ aspectRatio: "16/9" }}>
        <iframe
          title="video"
          src={`https://www.youtube.com/embed/${yt}`}
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) {
    return (
      <div className={`relative w-full overflow-hidden rounded-xl border border-white/10 ${className}`} style={{ aspectRatio: "16/9" }}>
        <iframe title="video" src={`https://player.vimeo.com/video/${vimeo[1]}`} className="absolute inset-0 w-full h-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  return (
    <video controls src={mediaUrl(url)} className={`w-full rounded-xl border border-white/10 ${className}`} />
  );
}
